module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEqSURBVHgBlVOBTcQwDHRQB3g2yAbfDQgT8BsAE8AGwATPBj8CbPBlgsIEXybobxDO9CI5URSopVMjO75zbUekYjHGAOyBEzDHxfR7BB4AX+a4gkAvHIAADMAnMQEa64Edzy/OuedaFZ4VKK6kYYjf8d4IbGokeaBNlnKO1nmg818kJq9n/0JyKMltcWlDVd8SQOzttyrD2ptgiLmNDSLt19zhnNTmFMQ0Bikm2rBJOToe1C6Bb6roiPeVpDNwDaGz8W2Vo4NzQqLuyo0sO5NUphpRQaKmooOwgkdurpcVxoGMWR7X/7Rij7J7F+Y8yLL6/g8CzwlnPezM+YvfrT5MWf49vTPti1YQKLRDr+4tkTNKqpL25ZUkPSEkU9J3kHxIo2Rt3NPaZ5LsByE+Dio4vdKHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/mangxian_bai.png
// module id = EMBE
// module chunks = 5